import { colors, fontSize, shorthandHelper, spacing } from '@offerzen/pinata-shame'
import { css } from '@emotion/css'

const styles = {
  adminLink: css({
    position: 'fixed',
    bottom: '0',
    right: '0',
    padding: shorthandHelper([spacing.small, spacing.extraLarge]),
    backgroundColor: colors.jungleGreen,
    color: colors.white,
    fontSize: fontSize.default,
  }),
}

export default styles
